import { ComponentStyleConfig } from "@chakra-ui/react";

export const ReiModal: ComponentStyleConfig = {
  baseStyle: {
    overlay: {
      bg: "rgba(20, 27, 43, 0.45)",
      backdropFilter: "blur(6px)",
    },
    dialog: {
      borderRadius: "3xl",
      boxShadow: "2xl",
      bg: "white",
    },
    header: {
      fontFamily: "heading",
      fontWeight: 700,
      letterSpacing: "-0.02em",
      color: "ink.DEFAULT",
      textAlign: "center",
      padding: "1.6rem",
    },
    footer: {
      padding: "2rem 1.6rem",
    },
    closeButton: {
      borderRadius: "full",
      top: 4,
      insetEnd: 4,
    },
  },
  defaultProps: {
    motionPreset: "slideInBottom",
  },
};
